document.addEventListener('Searchanise.Loaded', function() {
  (function($) {
    $(document).on("Searchanise.ResultsUpdated", function () {
      $('.snize-search-results .snize-product').each(function() {
        var productData = $(this).data("snize_item_data");
        this.setAttribute("data-product-id", productData.product_id);
        var metavalue = productData.metafield_3e8ca35afc83176eae6d0d7d8eef11bb;
        var palvaysValue = productData.metafield_a0f49b03493d666fad36e94f2766cf8d;

        // console.log(productData);
        //console.log(palvaysValue);

        // Get the current URL
        const url = window.location.href;
        let isKasvattaja = false;
        // Check if the URL contains 'kasvattajaklubi'

        if (url.includes('/collections/kasvattajaklubi')) {
            isKasvattaja = true;
        };
        let kasvattajaDiscount = 0;
        let kasvattajaText = "";
        if(isKasvattaja) {
          if(productData.tags.includes("Kasvattajaklubi-10%")) {
            kasvattajaDiscount = 0.10;
          } else if (productData.tags.includes("Kasvattajaklubi-15%")){
            kasvattajaDiscount = 0.15;
          } else if (productData.tags.includes("Kasvattajaklubi-20%")){
            kasvattajaDiscount = 0.20;
          } else if (productData.tags.includes("Kasvattajaklubi-25%")){
            kasvattajaDiscount = 0.25;
          } else if (productData.tags.includes("Kasvattajaklubi-30%")){
            kasvattajaDiscount = 0.30;
          }

          kasvattajaText = `-${kasvattajaDiscount * 100}%`
        }
        var qty = productData.quantity;
        let tags = productData.tags;
        let isPika = tags.includes("Toimitusaika_Pikatoimitus 1-3 vrk");
        let isTilaus = tags.includes("Toimitusaika_Tilaustuote 1-14 vrk");
        
        if(isKasvattaja && kasvattajaText != '' && !$('.snize-kasvattaja', '#snize-product-' + productData.product_id).length) {
          // This discount is calculated from the already discounted price
          const kasvattajaDiscountedPrice = Math.ceil(parseFloat(productData.price * 100) * (1 - kasvattajaDiscount))

          $('.snize-price-with-discount', '#snize-product-' + productData.product_id).remove();
          $('.snize-price', '#snize-product-' + productData.product_id).attr('class', 'snize-discounted-price money');
          $('.snize-price-list', '#snize-product-' + productData.product_id).prepend(`<span class="snize-price snize-price-with-discount money">${Shopify.formatMoney(kasvattajaDiscountedPrice)}</span>`);
          $('.snize-thumbnail-wrapper', '#snize-product-' + productData.product_id).after('<div class="snize-product-label top-left snize-kasvattaja">' + 'Kasvattaja ' + kasvattajaText +  '</div>');
        };
        if (isPika && isTilaus === false && !$('.snize-pikatoimitus', '#snize-product-' + productData.product_id).length) {
        	$('.snize-title', '#snize-product-' + productData.product_id).after('<span class="snize-attribute snize-pikatoimitus">'+"Pikatoimitus 1-3 vrk"+'</span>');
        };
        if (isTilaus && isPika === false && !$('.snize-tilaustuote', '#snize-product-' + productData.product_id).length) {
        	$('.snize-title', '#snize-product-' + productData.product_id).after('<span class="snize-attribute snize-tilaustuote">'+"Tilaustuote 1-14 vrk"+'</span>');
        };
        if (isTilaus && isPika && !$('.snize-pikatoimitus', '#snize-product-' + productData.product_id).length) {
          $('.snize-title', '#snize-product-' + productData.product_id).after('<span class="snize-attribute snize-pikatoimitus">'+"Pikatoimitus 1-3 vrk"+'</span>');
        };
        if (metavalue && !$('.snize-metafield-kayttotarkoitus', '#snize-product-' + productData.product_id).length) {
          $('.snize-description', '#snize-product-' + productData.product_id).before('<span class="snize-attribute snize-metafield-kayttotarkoitus">'+metavalue+'</span>');
        };
        if (palvaysValue && !$('.snize-metafield-paivays', '#snize-product-' + productData.product_id).length) {
          $('.snize-description', '#snize-product-' + productData.product_id).before('<span class="snize-attribute snize-metafield-paivays">'+"<strong>"+"Päiväys: "+"</strong>"+palvaysValue+'</span>');
        };
        if(qty == 0) {
          $('.snize-description', '#snize-product-' + productData.product_id).before('<span class="snize-out-of-stock">Loppu</span>');
        };
      });
    });
  })(window.Searchanise.$);
}); 